export default {
  name: 'mapconfigv2header',
  components: {},
  props: ['mapform'],
  data() {
    return {
      title: '',
      percentage: 100,
      screenIndex: 0
    };
  },
  mounted() {},
  watch: {},
  methods: {
    saveHandle() {
      this.$emit('save');
    },
    increase() {
      if (this.percentage <= 0) return;
      this.percentage -= 10;
      this.$emit('percentage', this.percentage);
    },
    decrease() {
      if (this.percentage >= 100) return;
      this.percentage += 10;
      this.$emit('percentage', this.percentage);
    },
    previewmap() {
      window.open(location.protocol + '//' + location.host + location.pathname + '#/superMapv2?' + location.hash.split('?')[1]);
    },
    screenswitch(index) {
      this.screenIndex = index;
      this.$emit('isMobile', index === 0 ? false : true);
    }
  }
};